import React, { useState } from "react";

import Footer from "../Components/Footer";
import Navbar3 from "../Components/Navbar3";
import ProgramGrid from "../Components/ProgramGrid";
import VolleyballPrograms from "../data/VolleyballPrograms";
import VBTournamentsPrograms from "../data/VBTournamentsPrograms";
import TextDivider from "../Components/TextDivider";

function Volleyball3() {
  const [programFilter, setProgramFilter] = useState("camps");

  return (
    <>
      <Navbar3 />

      <div className="event-experience-image">
        <img
          src="/s3/ads-volleyball-banner.jpg"
          alt="ADS Volleyball"
        />
      </div>

      <section className="camp-section">
        <div className="container">

          <div className="row">
            <div className="col-12 text-center">

              <h2 className="camp-section__title futuraPTMedium">
                CAMPS, CLINICS &amp; <br />
                TOURNAMENTS
              </h2>

            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-auto">

              <a
                href="/s3/uniform-packages.pdf"
                className="btn camp-section__button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-file-earmark-pdf-fill me-2"></i>

                DOWNLOAD UNIFORM PACKAGES
              </a>

            </div>
          </div>
        </div>
      </section>
      <div className="container">
         <div className="row justify-content-center mt-4">
            <div className="col-auto">

              <div
                className="btn-group"
                role="group"
                aria-label="Volleyball program filter"
              >

                <button
                  type="button"
                  className={
                    programFilter === "camps"
                      ? "btn btn-danger"
                      : "btn btn-outline-danger"
                  }
                  onClick={() =>
                    setProgramFilter("camps")
                  }
                >
                  CAMPS &amp; CLINICS
                </button>

                <button
                  type="button"
                  className={
                    programFilter === "tournaments"
                      ? "btn btn-danger"
                      : "btn btn-outline-danger"
                  }
                  onClick={() =>
                    setProgramFilter("tournaments")
                  }
                >
                  TOURNAMENTS
                </button>

              </div>

            </div>
            
        </div>
      </div>
      

      {programFilter === "camps" && (
        <ProgramGrid
          programs={VolleyballPrograms}
        />
      )}

      {programFilter === "tournaments" && (
        <>
          <ProgramGrid
            programs={VBTournamentsPrograms}
          />
        </>
      )}

      <TextDivider />
      <div>
        <section className="volleyball-elite">
          <div className="event-experience-image">
          <img
            src="/s3/volleyball-elite.jpg"
            alt="Number 2 Ranked Elite 11 Lonestar Region"
          />
        </div>
        </section>
      </div>
      <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="volleyball-coaches-title futuraPTMedium">
              VOLLEYBALL COACHES
            </h2>
          </div>
        </div>

        <div className="row g-5 volleyball-coaches-grid">

          <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/paltamarino.jpg"
                alt="Pat Altamarino"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                <a href="mailto:paltamirano@adssportscomplex.com">
                  Pat Altamirano</a>
              </h3>
            </div>
          </div>

           <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/mviernes.jpg"
                alt="Malia Viernes"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Malia Viernes
              </h3>
            </div>
          </div>

           <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/agabbin.jpg"
                alt="Angela Gabbin"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Angela Gabbin
              </h3>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/mreese.jpg"
                alt="Michael Reese"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Michael Reese
              </h3>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/abrown.jpg"
                alt="Amanda Brown"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Amanda Brown
              </h3>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/arogers.jpg"
                alt="Ashton Rogers"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Ashton Rogers
              </h3>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/kkrueger.jpg"
                alt="Karli Krueger"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Karli Krueger
              </h3>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="volleyball-coach">
              <img
                src="/s3/lroach.jpg"
                alt="Lily Roach"
                className="volleyball-coach-image"
              />

              <h3 className="volleyball-coach-name futuraPTMedium">
                Lily Roach
              </h3>
            </div>
          </div>

        </div>
      </div>

      <div className="container pb-5">
        <div className="row justify-content-center pb-5">
            <div className="col-auto">

              <a
                href="/s3/uniform-packages.pdf"
                className="btn camp-section__button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                DOWNLOAD UNIFORM PACKAGES
              </a>

            </div>
        </div>
      </div> 
      <TextDivider />
      <Footer />
    </>
  );
}

export default Volleyball3;